import useUserPermission from "~/hooks/useUserPermission";
import { USE_AI_AGENTS } from "~/router/permissions";

export const useCanUseAIAgents = (): boolean => useUserPermission(USE_AI_AGENTS);
